// lingland-frontend/src/pages/BlogPostCard.js
import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowRight, Tag, Clock } from 'lucide-react';
import './BlogPage.css';

export const BlogPostCard = ({ post }) => {
    const { t } = useTranslation(['translation', 'blog']);
    const imageWidth = 350;
    const imageHeight = 200;

    // Tworzymy dynamiczne klucze do tłumaczeń na podstawie ID posta
    const titleKey = `post${post.id}_title`;
    const excerptKey = `post${post.id}_excerpt`;
    const categoryKey = `post${post.id}_category`;

    return (
        <Link to={`/blog/${post.slug}`} className="blog-post-card-link">
            <div className="blog-post-card blog-page-card">
                <img 
                    src={post.image} 
                    alt={t(titleKey, { ns: 'blog' })} 
                    className="blog-post-image" 
                    loading="lazy"
                    width={imageWidth}
                    height={imageHeight}
                />
                <div className="blog-content">
                     <div className="blog-meta">
                        <span className="blog-category"><Tag size={14}/> {t(categoryKey, { ns: 'blog' })}</span>
                        <span className="blog-date"><Clock size={14}/> {post.date}</span>
                     </div>
                    <h4>{t(titleKey, { ns: 'blog' })}</h4>
                    <p>{t(excerptKey, { ns: 'blog' })}</p>
                    <span className="read-more-link">
                        {t('common_read_more')} <ArrowRight size={18} />
                    </span>
                </div>
            </div>
        </Link>
    );
};